import { FC, Suspense, useEffect, useMemo } from 'react';
import { I18nextProvider } from 'react-i18next';
import { Route, Routes } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { HomePage } from 'pages/Home/HomePage';
import { getCookie } from 'shared/lib/getCookie';
import { getCulture } from 'shared/lib/getCulture';
import { getNewI18n } from 'shared/lib/i18n/i18nInstance';
import { FullPageLoader } from 'shared/ui/Loader/FullPageLoader';
import { AuthProvider } from './providers/AuthProvider';
import { LoaderProvider } from './providers/LoaderProvider';

import './reset.css';
import './index.css';
import 'shared/assets/fonts/stylesheet.css';

interface AppProps {
	basename?: string;
}

const queryClient = new QueryClient();

export const App: FC<AppProps> = ({ basename = `` }) => {
	const i18n = useMemo(() => getNewI18n(getCulture()), []);

	const theme = getCookie(`CP_SAS_PORTAL_PLATTFORM`);

	useEffect(() => {
		if (theme) {
			document.body.classList.add(theme);
		}
	}, [theme]);

	return (
		<div className='app'>
			<Suspense fallback={<FullPageLoader />}>
				<QueryClientProvider client={queryClient}>
					<I18nextProvider i18n={i18n}>
						<AuthProvider>
							<LoaderProvider>
								<BrowserRouter basename={basename}>
									<Routes>
										<Route path='*' element={<HomePage />} />
									</Routes>
								</BrowserRouter>
							</LoaderProvider>
						</AuthProvider>
					</I18nextProvider>
				</QueryClientProvider>
			</Suspense>
		</div>
	);
};
